import {
  Avatar,
  Box,
  Button,
  CircularProgress,
  DialogActions,
  IconButton,
  Menu,
  MenuItem,
  Typography
} from '@mui/material'
import React, { useContext, useRef, useState } from 'react'
import { PrimaryDots } from '../../assets/images'
import { CANCEL } from '../../constants'
import { AppContext } from '../../context'
import { ActionType } from '../../context/AppContextReducer'
import { anchorOrigin, menuPaperStyles, transformOrigin } from '../../theme/styleConstants'
import { CustomModal } from '../common/CustomModal'

// others

interface CustomMenuProps {
  id: string
  modal: JSX.Element
  menuTitle: string
  onDelete: (id: string) => void
  deleting: boolean
  deleteContent: JSX.Element
  hideDelete?: boolean
  handleEdit?: () => void
  deleteLabel?: string
}
const CustomMenu = ({
  id,
  modal,
  menuTitle,
  deleting,
  deleteContent,
  onDelete,
  handleEdit,
  hideDelete = false,
  deleteLabel = 'Delete'
}: CustomMenuProps) => {
  const [open, setOpen] = useState(false)
  const [isEditOpen, setIsEditOpen] = useState(false)
  const { dispatch, isDeleteOpen } = useContext(AppContext)

  const anchorRef = {
    [id]: useRef<HTMLButtonElement>(null)
  }

  const handleMenuClick = (type: string) => {
    if (type === 'DELETE') dispatch({ type: ActionType.SET_IS_DELETE_OPEN, isDeleteOpen: !isDeleteOpen })
    // else dispatch({ type: ActionType.SET_IS_EDIT, isEdit: !isEdit })
    else setIsEditOpen(true)
  }

  const handleClick = () => {
    handleEdit?.()
    return setOpen(!open)
  }

  const handleClose = () => {
    dispatch({ type: ActionType.SET_IS_DELETE_OPEN, isDeleteOpen: false })
    // dispatch({ type: ActionType.SET_IS_EDIT, isEdit: false })
    setIsEditOpen(false)
    return setOpen(false)
  }

  const clonedModal = React.cloneElement(modal, {
    isOpen: isEditOpen,
    handleClose: handleClose
  })

  return (
    <Box>
      <IconButton
        ref={anchorRef[id]}
        id={`long-button-${id}`}
        aria-controls={`long-menu-${id}`}
        aria-haspopup="true"
        onClick={handleClick}
        aria-label="show more"
      >
        <Avatar sx={{ bgcolor: 'transparent' }}>
          <PrimaryDots />
        </Avatar>
      </IconButton>

      <Menu
        id={`long-menu-${id}`}
        anchorEl={anchorRef[id].current}
        open={open}
        anchorOrigin={anchorOrigin}
        transformOrigin={transformOrigin}
        onClose={handleClose}
        PaperProps={menuPaperStyles}
      >
        <div>
          <MenuItem
            onClick={event => {
              event.stopPropagation()
              return handleMenuClick('EDIT')
            }}
          >
            Edit
          </MenuItem>
          {!hideDelete && <MenuItem onClick={() => handleMenuClick('DELETE')}>{deleteLabel}</MenuItem>}
        </div>

        <CustomModal isOpen={isDeleteOpen} handleClose={handleClose} title={`${deleteLabel} ${menuTitle}`}>
          <Typography variant="body1">You are about to {deleteLabel.toLowerCase()} the following {menuTitle}:</Typography>
          {deleteContent}

          <DialogActions sx={{ padding: '30px 0 0', flexWrap: 'wrap' }}>
            <Button onClick={handleClose} variant="outlined" aria-label={CANCEL}>
              {CANCEL}
            </Button>

            <Button
              onClick={() => onDelete(id)}
              color="primary"
              variant="contained"
              endIcon={deleting && <CircularProgress size={20} color="inherit" />}
              aria-label="delete category"
            >
              {deleteLabel} {menuTitle}
            </Button>
          </DialogActions>
        </CustomModal>

        {clonedModal}
      </Menu>
    </Box>
  )
}

export default CustomMenu
